var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "skpfull_wrap", attrs: { id: "wrap" } }, [
    _c("div", { staticClass: "rd_box register" }, [
      _c("div", { staticClass: "container register step3" }, [
        _c("div", { staticClass: "title" }, [
          _c("h1", [_vm._v(_vm._s(_vm.$t("TITLE.EUR.SIGNUP.REQUEST")))])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content", attrs: { "ng-init": "" } }, [
          _c(
            "div",
            { staticClass: "one-register" },
            [
              _c("div", { staticClass: "register_step" }, [
                _c("ul", [
                  _c("li", [
                    _c("em", [_vm._v("1")]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("TITLE.EUR.TERMS")))])
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _c("em", [_vm._v("2")]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("TITLE.EUR.SIGN.UP")))])
                  ]),
                  _vm._v(" "),
                  _c("li", { staticClass: "active" }, [
                    _c("em", [_vm._v("3")]),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.REQUEST")))])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "keep-alive",
                [_c("req-repair-info", { attrs: { bIndependent: false } })],
                1
              )
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5aa3cd2c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5aa3cd2c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/basis/eur/user/JoinUserStep3.vue
// module id = kXEK
// module chunks = 0